
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/surroundings",
      function () {
        return require("private-next-pages/locale/surroundings.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/surroundings"])
      });
    }
  